import { render, staticRenderFns } from "./DigitalResultsView.vue?vue&type=template&id=3ef3a9ed&scoped=true"
import script from "./DigitalResultsView.vue?vue&type=script&lang=js"
export * from "./DigitalResultsView.vue?vue&type=script&lang=js"
import style0 from "./DigitalResultsView.vue?vue&type=style&index=0&id=3ef3a9ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3a9ed",
  null
  
)

export default component.exports